/** Ключи, выбранные последними (новые первыми), из хранилища браузера. Хранилище недоступно — пусто. */
export const readPickerRecent = (storageKey: string, limit: number): string[] => {
    try {
        const parsed: unknown = JSON.parse(localStorage.getItem(storageKey) ?? '[]');
        return Array.isArray(parsed)
            ? parsed.filter((key): key is string => typeof key === 'string').slice(0, limit)
            : [];
    } catch {
        return [];
    }
};

export const rememberPickerRecent = (storageKey: string, keys: string[], limit: number) => {
    try {
        const next = [...new Set([...keys, ...readPickerRecent(storageKey, limit)])].slice(0, limit);
        localStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
        // недоступное хранилище — без «Недавних»
    }
};
